<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
    >
      <template slot="items" slot-scope="props">
        <!--<td>{{ props.item.id }}</td>-->
        <td>{{ props.item.name }}</td>
        <!--<td>{{ props.item.description }}</td>-->
        <!--<td>{{ props.item.is_vendor }}</td>-->
        <!--<td>{{ props.item.created_at }}</td>-->
        <!--<td>{{ props.item.updated_at }}</td>-->
        <td class="text-xs-right">
          <v-tooltip top>
            <v-btn slot="activator" icon class="mx-0" @click="editElementChecklist(props.item.id)">
              <v-icon color="light-blue lighten-2">format_list_numbered</v-icon>
            </v-btn>
            Edit products & checklist
          </v-tooltip>
          <v-tooltip top v-if="!$can('view', 'vendor')">
            <v-btn slot="activator" icon class="mx-0" @click="deleteElement(props.item.id)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            Remove user products
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <slot name="bottom" :casesid="casesid" :loadListing="loadListing" :itemForCheckList="itemForCheckList"></slot>

  </div>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import resourcesMixins from '@/mixins/Resources'
  import itemTypesMixins from '@/mixins/ItemTypes'

  export default {
    mixins: [ resourcesMixins, itemTypesMixins ],
    data () {
      return {
        tableHeaders: [
          // { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          // { text: 'Description', value: 'description' },
          // { text: 'Is external vendor', value: 'is_vendor' },
          // { text: 'Created at', value: 'created_at' },
          // { text: 'Updated at', value: 'updated_at' },
          { text: 'Actions', value: 'actions', align: 'right' }
        ],
        items: [],
        itemForCheckList: { id: 0 }
      }
    },
    computed: {
      resources () {
        return 'cases/' + this.casesid + '/' + this.entity
      },
      entity () {
        switch (this.itemType) {
          case this.inventoryTypeID: return 'inventory'
          case this.serviceTypeID: return 'user'
          // case this.serviceTypeID: return 'service'
        }
      }
    },
    methods: {
      deleteElementSuccess () {
        this.loadListing()
        this.$store.dispatch('loadAllCases')
      },
      loadListing () {
        let result = null

        switch (this.itemType) {
          case this.inventoryTypeID:
            result = casesAPI.getLinkedInventories(this.casesid)
            break
          case this.serviceTypeID:
            result = casesAPI.getLinkedVendors(this.casesid)
            // result = casesAPI.getLinkedServices(this.casesid)
            break
        }

        result.then(result => {
          this.items = result
        }, this.loadListingError)
      },
      editElementChecklist (itemId) {
        this.itemForCheckList.id = itemId
      }
    },
    props: {
      casesid: {
        type: Number,
        required: true
      },
      itemType: {
        type: Number,
        required: true
      }
    },
    created () {
      this.loadListing()
    }
  }
</script>



// WEBPACK FOOTER //
// AppCaseItemsDataTableBase.vue?034e31bc